






























import ReloadButton from '@/components/BaseReloadButton.vue';
import Grid from '@/components/Grid.vue';
import GridFileItem from '@/components/GridFileItem.vue';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import SortSelector from '@/components/SortSelector.vue';
import IntervalReloadMixin from '@/mixins/interval-reload';
import OpenFileMixin from '@/mixins/open-file';
import { FileActions } from '@/store/file/actions.enum';
// eslint-disable-next-line import/order
import Vue from 'vue';
// eslint-disable-next-line import/order
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  name: 'Highlights',

  mixins: [OpenFileMixin, IntervalReloadMixin],

  components: {
    ReloadButton,
    Grid,
    GridFileItem,
    LoadingSpinner,
    SortSelector,
  },

  computed: {
    ...mapGetters('file', { items: 'highlights', loading: 'loading' }),
  },

  methods: {
    ...mapActions('file', { fetchHighlights: FileActions.FETCH_HIGHLIGHTS }),

    async reload() {
      await this.fetchHighlights();
    },
  },
});
